import MobileLandingSection from './mobile-landing-section';

export default MobileLandingSection;
